"use client";

import type { AddonDietAddonsRead } from "@repo/api/catalog/api/schemas/addon-diet-addons-read";
import { useEffect, useMemo } from "react";
import {
  buildAddonGtmItem,
  getAddonSelectionValue,
} from "@/features/addons/lib/addon-gtm-item";
import { sendEvent } from "../gtm/event";

type UseAddonViewItemEventParams = {
  addon: AddonDietAddonsRead | null;
  cateringName?: string;
  categoryName?: string;
  selectedDates: Date[];
  totalQuantity: number;
  enabled: boolean;
};

export const useAddonViewItemEvent = ({
  addon,
  cateringName,
  categoryName,
  selectedDates,
  totalQuantity,
  enabled,
}: UseAddonViewItemEventParams) => {
  const item = useMemo(
    () =>
      addon
        ? buildAddonGtmItem({
            addon,
            cateringName,
            categoryName,
            selectedDates,
            quantity: totalQuantity,
          })
        : null,
    [addon, cateringName, categoryName, selectedDates, totalQuantity],
  );

  useEffect(() => {
    if (!(enabled && addon && item)) {
      return;
    }

    sendEvent({
      event: "view_item",
      ecommerce: {
        currency: "PLN",
        value: getAddonSelectionValue(addon, totalQuantity),
        items: [item],
      },
    });
  }, [enabled, addon, item, totalQuantity]);
};
